import classnames from 'classnames';
import {
  CKContainerProps,
  CKHTMLElement,
  CKHTMLElementProps,
  CKLayoutGrid,
} from 'clearkit';
import { CSSProperties, FC } from 'react';

type GridListProps = CKHTMLElementProps & {
  gridGap?: string;
  gridTemplateColumns?: string;
};

type GridListItemProps = CKContainerProps & {
  hasDivider?: boolean;
};

type GridListComposition = {
  Header: FC<CKContainerProps>;
  Item: FC<GridListItemProps>;
};

export const GridList: FC<GridListProps> & GridListComposition = ({
  children,
  gridTemplateColumns,
  gridGap = '1rem',
  ...rest
}) => (
  <CKHTMLElement
    {...rest}
    style={
      {
        '--layout-grid-template-columns': gridTemplateColumns,
        '--layout-grid-template-rows': 'initial',
        '--layout-gap': gridGap,
      } as CSSProperties
    }
  >
    {children}
  </CKHTMLElement>
);

GridList.Header = ({ className, ...rest }) => (
  <CKLayoutGrid
    {...rest}
    as="header"
    className={classnames('font-medium min-w-0', className)}
  />
);
GridList.Header.displayName = 'GridList.Header';

GridList.Item = ({ className, hasDivider = true, ...rest }) => (
  <CKLayoutGrid
    {...rest}
    className={classnames('min-w-0', className, {
      'border-b last:border-none pb-4': hasDivider,
    })}
  />
);
GridList.Item.displayName = 'GridList.Item';
